//#region src/core/ui/menu/vars.ts
/** CSS custom property names for menu layout and positioning. */
const MenuCSSVars = {
	/** Width of the active menu panel (px). */
	width: "--media-menu-width",
	/** Height of the active menu panel (px). */
	height: "--media-menu-height",
	/** Viewport-constrained max width for the menu (px). */
	availableWidth: "--media-menu-available-width",
	/** Viewport-constrained max height for the menu (px). */
	availableHeight: "--media-menu-available-height"
};
//#endregion
export { MenuCSSVars };

//# sourceMappingURL=vars.js.map